export let Specs = /*#__PURE__*/function (Specs) {
  Specs["BLOCK_TRANSFER_GATE"] = "specs.premium.domains.blockTransferGate";
  Specs["DOMAIN_ASSIGNMENT_FED_MIGRATION"] = "specs.premium.domains.domainsAssignmentFedMigration";
  return Specs;
}({});
//# sourceMappingURL=Specs.js.map